export interface Person {
  firstName: string
  lastName: string
  middleName?: string
}

export function fullName(person: Person): string {
  let { firstName, middleName, lastName } = person

  if (middleName) {
    return `${lastName}, ${firstName} ${middleName}`
  } else {
    return `${lastName}, ${firstName}`
  }
}
